import Header from '../../header/Header';
import axios from 'axios';
import { useContext } from 'react';
import { FaUsersCog } from "react-icons/fa";

import './dashboard.scss'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { allUser, addUser, deleteUser, editUser } from '../../api/User';
import { ThemeContext } from '../../App';
import Menu from '../../Components/menu';


import React, { useState, useEffect } from 'react';


function List() {
  const Theme = useContext(ThemeContext);

  const [card, setCard] = useState([]);
  const [cardUpdate, setCardUpdate] = useState([]);

  // fech api/v1/printer data and set to card
  useEffect(() => {

    getPrinter();
  }, []);



  const getPrinter = async () => {
    try {
      const response = await fetch('/api/v1/printer', { method: 'GET' });
      if (response.ok) {
        const data = await response.json();
        setCard(data.data);
      } else {
        console.error(`Error: ${response.status}`);
      }
    } catch (error) {
      console.error(error);
    }
    console.log(card);
  };

  const print = () => {

    fetch('/print', { method: 'GET' })
    setTimeout(() => {
      getPrinter();
    }, 1000);
  };
  const printType = async (id,type) => {
    await axios.get(`/update-printer/${id}/${type}`);
    getPrinter();
  };


      
  //[{"_id":"63a8aa3752f58eb2077491dd","name":"Print2Flash 5 Free Printer","displayName":"Print2Flash 5 Free Printer","description":"","status":0,"isDefault":false,"options":{"printer-location":"","printer-make-and-model":"Print2Flash 5 Free Printer Driver","system_driverinfo":"Print2Flash 5 Free Printer Driver;5.0 built by: WinDDK;Print2Flash Printer;5.0"},"createdAt":"2022-12-25T19:53:27.291Z","updatedAt":"2022-12-25T19:53:27.291Z","__v":0},{"_id":"63a8aa3752f58eb2077491e5","name":"Fax","displayName":"Fax","description":"","status":0,"isDefault":false,"options":{"printer-location":"","printer-make-and-model":"Microsoft Shared Fax Driver","system_driverinfo":"Microsoft Shared Fax Driver;10.0.22621.755 (WinBuild.160101.0800);Microsoft® Windows® Operating System;10.0.22621.755"},"createdAt":"2022-12-25T19:53:27.308Z","updatedAt":"2022-12-25T19:53:27.308Z","__v":0},{"_id":"63a8aa3752f58eb2077491df","name":"PDF Printer","displayName":"PDF Printer","description":"","status":0,"isDefault":false,"options":{"printer-location":"C:\\Program Files\\PDF Printer for Windows 11","printer-make-and-model":"PDF Printer x64 Driver","system_driverinfo":"PDF Printer x64 Driver;0.3.2.350;PDF Printer for Windows 9;2.0.0.525"},"createdAt":"2022-12-25T19:53:27.298Z","updatedAt":"2022-12-25T19:53:27.298Z","__v":0},{"_id":"63a8aa3752f58eb2077491e3","name":"Microsoft Print to PDF","displayName":"Microsoft Print to PDF","description":"","status":0,"isDefault":true,"options":{"printer-location":"","printer-make-and-model":"Microsoft Print To PDF","system_driverinfo":"Microsoft Print To PDF;10.0.22621.900 (WinBuild.160101.0800);Microsoft® Windows® Operating System;10.0.22621.900"},"createdAt":"2022-12-25T19:53:27.305Z","updatedAt":"2022-12-25T19:53:27.305Z","__v":0},{"_id":"63a8aa3752f58eb2077491e1","name":"Microsoft XPS Document Writer","displayName":"Microsoft XPS Document Writer","description":"","status":0,"isDefault":false,"options":{"printer-location":"","printer-make-and-model":"Microsoft XPS Document Writer v4","system_driverinfo":"Microsoft XPS Document Writer v4;10.0.22621.900 (WinBuild.160101.0800);Microsoft® Windows® Operating System;10.0.22621.900"},"createdAt":"2022-12-25T19:53:27.302Z","updatedAt":"2022-12-25T19:53:27.302Z","__v":0}]
  return (
    <div className='dashboard' >
      <Menu />
      <div className='body'>
        <h1> <FaUsersCog size={28} /> Printer</h1>
        <p> overview of your printer </p>

        <button className='btn btn-primary' onClick={print}>Print</button>
        <div className="prinerlist row row-cols-1 row-cols-md-3 g-4 justify-content-center align-items-center mt-5">
          {card.map((item, index) => {
            return (
              <div className="card " key={index}>
                <div className="card-body">
                  <h4 className="card-title">{item.type}</h4>
                  <h5 className="card-title">{item.name}</h5>
                  <h6 className="card-subtitle mb-2 text-muted">{item.displayName}</h6>
                  <p className="card-text">{item.description}</p>
                  <p className="card-text">{item.status}</p>
                  <button onClick={() => printType(item._id, 'kitchen')} className="btn btn-primary">Kitchen</button>
                  <button onClick={() => printType(item._id, 'bar')} className="btn btn-primary">Bar</button> 

                </div>
              </div>
            );
          })}

        </div>
      </div>
    </div>
  );
}


function Printer() {
  return (
    <div>
      <Header />
      <div className=" admin-Product">

        <List />
      </div>
    </div>
  );
}


export default Printer;